import _ from 'underscore';

export default class UserBuyerEdit {
  constructor($scope) {
    const hide_pages = ['edit_orders', 'edit_orders_customers', 'offer_request_selections', 'offer_request_reservations'];
    $scope.show_sidebar = !_.contains(hide_pages, window.app_data.action);
  }
}

UserBuyerEdit.$inject = ['$scope'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-buyer-edit.ctrl.js